import { useCallback } from "react";
import { useLanguage } from "../../../context/LanguageContext";
import { useApiQuery } from "../../useApiQuery";

export type HistoryEntry = {
    TYPE: string;
    UPDATE_DATE: string;
    UPDATE_SOURCE: string;
    MOTIF: string;
    DETAIL: string;
};

const useGetPersonHistory = () => {
    const { t } = useLanguage();
    const { data: history, isLoading, error, fetch, reset: resetHistory } = useApiQuery<HistoryEntry[]>(
        "/getPersonHistory",
        {
            withWorkspace: false,
            initialData: [],
            transform: (raw) => (Array.isArray(raw) ? (raw as HistoryEntry[]) : []),
            defaultError: t("pages.customers.dashboard.history.unknownError"),
        }
    );

    const getPersonHistory = useCallback(
        (personId: string | number) => fetch({ person_id: personId }),
        [fetch]
    );

    return { history, isLoading, error, getPersonHistory, resetHistory };
};

export default useGetPersonHistory;
